import { render, staticRenderFns } from "./ConfiguracionCliente.vue?vue&type=template&id=5e5e49c0&scoped=true&"
import script from "./ConfiguracionCliente.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionCliente.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ConfiguracionCliente.vue?vue&type=style&index=1&id=5e5e49c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e49c0",
  null
  
)

export default component.exports